import { useEffect } from 'react';
import AddCompetence from '@/components/Competencies/CreateFlow/AddCompetence';

export const CompetenciesLesson = ({
  setAddList,
  addList,
  setDeleteList,
  deleteList,
  lesCompetencies,
  newLesCompetencies,
  setNewLesCompetencies,
  setIsOpenAddCompetencies,
  isDirectory,
}) => {
  useEffect(() => {
    const deletedIds = new Set(deleteList.map((item) => item.competenceId));

    const resultList = [
      ...lesCompetencies.filter((item) => !deletedIds.has(item.competenceId)),
      ...addList.map((item) => ({
        ...item,
      })),
    ];
    setNewLesCompetencies(resultList);
  }, [addList, deleteList, lesCompetencies]);

  return (
    <div className="">
      <AddCompetence
        title={`pages.create_edit_course.competence_add.title_${
          isDirectory ? 'dir' : 'les'
        }`}
        text={`pages.create_edit_course.competence_add.text_${
          isDirectory ? 'dir' : 'les'
        }`}
        info_text={`pages.create_edit_course.competence_add.info_text_${
          isDirectory ? 'dir' : 'les'
        }`}
        setDeleteList={setDeleteList}
        setAddList={setAddList}
        addList={addList}
        listCompetencies={newLesCompetencies}
        setIsOpenAddCompetencies={setIsOpenAddCompetencies}
      />
    </div>
  );
};
